const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
    '& th': {
      color: 'black',
      fontWeight: 900,
    },
    '& thead': {
      borderTop: '1px solid #ebebeb'
    }
  },
  pass: {
    color: "#43A547"
  },
  fail:{
    color: "#ff5252"
  }
})

export default styles
